export enum Country {
  France = 'FR',
  Canada = 'CA',
  UnitedStates = 'US',
  Unknown = '?',
}
